import React from "react";
import styled from "styled-components";

import Box, { BoxProps } from "./Box";
import FlexBox from "./FlexBox";

interface StyledPaneProps {
  flex?: boolean;
  scroll?: "x" | "y" | "both";
}
const StyledPane = styled(Box)<StyledPaneProps>`
  ${(props) => {
    if (props.flex) {
      return `flex: 1;`;
    }
  }}
  ${(props) => {
    if (props.scroll === "y") {
      return `overflow-y: auto;`;
    }
  }}
`;

const Styled = styled(FlexBox)<Props>`
  flex-direction: ${(props) =>
    props.direction === "vertical" ? "column" : "row"};

  ${(props) => {
    if (props.direction === "horizontal") {
      return `height: 100%;`;
    }
    if (props.direction === "vertical") {
      return `
      height: 100%;
      min-height: 0;
      `;
    }
  }}
`;

interface Props extends BoxProps {
  direction?: "vertical" | "horizontal";
}

/** @deprecated import from `cms`, really should die sometime */
const PaneLayout: React.FC<React.PropsWithChildren<Props>> & {
  Pane: typeof StyledPane;
} = (props) => {
  return <Styled {...props}>{props.children}</Styled>;
};

PaneLayout.Pane = StyledPane;
export default PaneLayout;
